<div mat-dialog-title>
  <div class="page-title-icon">
    <span class="card-header-value dialogue-tittle"> Consent </span>
    <p class="subtitle">
      Before you continue, it is important that you read carefully through the following statements and check all that you are in agreement with.
    </p>
  </div>
</div>
  <mat-dialog-content class="mat-typography">
    <form [formGroup]="consentForm" (ngSubmit)="onSubmit(consentForm)" validate autocomplete="off">
      <div class="card-row" *ngFor="let c of consents">
        <div class="card-column checkbox-flex">
        <mat-checkbox class="mt-5" [attr.aria-label]="c.id" [formControlName]="'consent_' + c.id" [id]="'consent_' + c.id"
          (keydown)="onFocusEvent($event)" [required]="c.mandatory">
        </mat-checkbox>
          <span class="checkbox-label">{{ c.description }}
          <span *ngIf="c.mandatory" class="mandatory-asterisk">*</span>

          </span>
        </div>
      </div>

  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close type="button" id="cancel_user_button" (click)="dialogRef.close(false)"
      mat-stroked-button>Cancel</button>
    <button mat-button [mat-dialog-close]="true" type="submit" id="save_order_test_button" mat-flat-button
      color="primary" [disabled]="!consentForm.valid">Save & proceed</button>
  </mat-dialog-actions>
</form>
</mat-dialog-content>